import { useCallback, useMemo, useState } from 'react';

export type SliderType = 'spend' | 'save' | 'cash';

export const useCountCalculatorInteractions = () => {
    const [timeFrameChangedCount, setTimeFrameChangedCount] = useState(0);
    const [limitExceededCount, setLimitExceededCount] = useState(0);
    const [sliderInteractionsCount, setSliderInteractionsCount] = useState({
        spend: 0,
        save: 0,
        cash: 0,
    });

    const interactionEventData = useMemo(() => {
        const { spend, save, cash } = sliderInteractionsCount;
        return {
            calculatorTimeFrameChangedCount: timeFrameChangedCount,
            calculatorLimitExceededCount: limitExceededCount,
            calculatorSliderSpendMoveCount: spend,
            calculatorSliderSaveMoveCount: save,
            calculatorSliderCashMoveCount: cash,
        };
    }, [timeFrameChangedCount, limitExceededCount, sliderInteractionsCount]);

    const resetInteractionEventData = useCallback(() => {
        setTimeFrameChangedCount(0);
        setLimitExceededCount(0);
        setSliderInteractionsCount({
            spend: 0,
            save: 0,
            cash: 0,
        });
    }, []);

    const handleTimeFrameChange = useCallback(() => {
        setTimeFrameChangedCount((count) => count + 1);
    }, []);

    const handleLimitExceeded = useCallback(() => {
        setLimitExceededCount((count) => count + 1);
    }, []);

    const handleSliderInteraction = useCallback((slider: SliderType) => {
        setSliderInteractionsCount((prev) => ({
            ...prev,
            [slider]: prev[slider] + 1,
        }));
    }, []);

    return {
        interactionEventData,
        resetInteractionEventData,
        handleTimeFrameChange,
        handleLimitExceeded,
        handleSliderInteraction,
    };
};
